<template>
  <v-dialog v-model="dialog" persistent scrollable width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Período
      </v-card-title>
      <v-card-text>
        <v-layout wrap justify-left align-center>
          <v-flex>
            <h4>{{title}}</h4>
            <v-layout row wrap>
              <v-flex xs6>
                <p-date-time v-if="dateTime"
                              label="Início"
                              v-model="interval.begin"
                              :defaultHour="'00:00'">
                </p-date-time>
                <p-date v-else
                              label="Início"
                              v-model="interval.begin">
                </p-date>
              </v-flex>
              <v-flex xs6>
                <p-date-time v-if="dateTime"
                              label="Fim"
                              v-model="interval.end"
                              :defaultHour="'23:59'">
                </p-date-time>
                <p-date v-else
                              label="Fim"
                              v-model="interval.end">
                </p-date>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mx-1" color="primary darken-1" :disabled="interval.end === '' && interval.begin === ''" @click="changeInterval()">Aplicar</v-btn>
        <v-btn class="mx-1" @click="close()">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PDate from './../shared/PDate'
import PDateTime from './../shared/PDateTime'

export default {
  components: {PDate, PDateTime},
  props: {
    dialog: false,
    title: {
      type: String,
      default: 'Período'
    },
    dateTime: false
  },
  data: () => ({
    interval: {begin: '', end: ''}
  }),
  methods: {
    close () {
      this.$emit('close')
      this.interval = {begin: '', end: ''}
    },
    changeInterval () {
      this.$emit('change', this.interval)
      this.$emit('close')
      this.interval = {begin: '', end: ''}
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/PPeriodDialog.vue